import script from "./entry-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./entry-edit.vue?vue&type=script&setup=true&lang=js"

import "./entry-edit.vue?vue&type=style&index=0&id=6d5a0440&lang=css"

const __exports__ = script;

export default __exports__